import axios from '@_system/axios/axios.js'
export default {
	path: '/wechaty',
	list(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	allRooms(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path +'/allRooms', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	addgroup(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path +'/addgroup', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	
	getMessage(id,data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path+'/getMessage/'+id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getPurchase(id,data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path+'/getPurchase/'+id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	sendmessagetask(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/sendmessagetask', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	setmark(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/setmark', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	
	getPurchaseDetail(id,data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path+'/getPurchaseDetail/'+id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},

}